<!-- <div class="background"></div> -->
<div class="background" theme [styleObj]='brandStyleCustomProperties'>
  <div class="blur">
    <router-outlet></router-outlet>
  </div>
</div>
